import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Problem from "@/components/Problem";
import Solution from "@/components/Solution";
import Technology from "@/components/Technology";
import Applications from "@/components/Applications";
import Finance from "@/components/Finance";
import Startup from "@/components/Startup";
import News from "@/components/News";
import LeadForm from "@/components/LeadForm";
import Footer from "@/components/Footer";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import Faq from "@/components/Faq";
import CookieBanner from "@/components/CookieBanner";
import { LangProvider, useLang } from "@/i18n";

function Home() {
  const { lang, t } = useLang();

  useEffect(() => {
    document.documentElement.lang = lang;
    document.title = lang === "en"
      ? "VPS Group — Diamond Sky | Industrial concentrated solar thermal"
      : "VPS Group — Diamond Sky | Solare termodinamico industriale";
  }, [lang]);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Problem />
        <Solution />
        <Applications />
        <Technology />
        <Finance />
        <Startup />
        <News />
        <Faq />
        <LeadForm />
      </main>
      <Footer />
      <CookieBanner />
    </>
  );
}

export default function App() {
  return (
    <div className="bg-anthracite min-h-screen" data-testid="app-root">
      <BrowserRouter>
        <LangProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/privacy" element={<Legal type="privacy" />} />
            <Route path="/termini" element={<Legal type="termini" />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </LangProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}
